enum TopicPurpose {
  DEFAULT = 'default',
  INSPIRATION = 'inspiration',
  INSPIRATION_FALLBACK = 'inspirationFallback',
  NEWS = 'news',
}

export default TopicPurpose;
